import React from 'react';
import DeviceCaseSupportedDiagnoseDetailsBattery from './components/DeviceCaseSupportedDiagnoseDetailsBattery';
import DeviceCaseSupportedDiagnoseDetailsMotherboard from "./components/DeviceCaseSupportedDiagnoseDetailsMotherboard";
import DeviceCaseSupportedDiagnoseDetailsKeyboard from "./components/DeviceCaseSupportedDiagnoseDetailsKeyboard";
import DeviceCaseSupportedDiagnoseDetailsLiveCall from "./components/DeviceCaseSupportedDiagnoseDetailsLiveCall";
import DeviceCaseSupportedDiagnoseDetailsBatteryDischarge from "./components/DeviceCaseSupportedDiagnoseDetailsBatteryDischarge";

function DeviceCaseSupportedDiagnoseDetails(props) {
    const Key = props.location.state?.redirectOptions?.rowData?.Key;
    switch (Key) {
        case 'motherboard':
            return <DeviceCaseSupportedDiagnoseDetailsMotherboard {...props} />;
        case 'battery_capacity':
            return <DeviceCaseSupportedDiagnoseDetailsBattery {...props} />;
        case 'keyboard':
            return <DeviceCaseSupportedDiagnoseDetailsKeyboard {...props} />;
        case 'livecall':
            return <DeviceCaseSupportedDiagnoseDetailsLiveCall {...props} />;
        case 'battery_discharge':
            return props.location.state?.redirectOptions?.rowData?.ClientType === 'mobile' ? <DeviceCaseSupportedDiagnoseDetailsBatteryDischarge {...props} /> : null;
        default:
            return null;
    }

}

export default DeviceCaseSupportedDiagnoseDetails
